import { css, Global } from '@emotion/core';
import { createElement } from 'react';

/**
 * 修正非推奨
 * ・修正する場合は、「影響する要素を検索で洗い出し、それをブラウザで目視確認」または、それに相当する確認を行うこと。
 */
const GlobalStyles = () => (
  <Global
    styles={css`
      * {
        margin: 0;
        box-sizing: border-box;
      }
      html,
      body {
        width: 100%;
        height: 100%;
        line-height: 1;
        background-color: #f9fafb;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 0;
      }
      #app {
        width: 100%;
        height: 100%;
      }
    `}
  />
);

export default GlobalStyles;
